<template>
  <div class="py-4 col-md-12 px-0">

    <div class="row no-gutters">

      <!-- イベント情報 -->
      <!-- Mobile -->
      <template v-if="isMobileBreakpoint">

        <template v-for="(eventPrice, key) of eventPrices">
          <div class="catalog-info-area-mobile col-12">
            <p class="order-no px-1 mb-0 w-100"><trans-text i18nKey="ui[7][4]"/>: {{getEventNameById(key).name}}</p>
          </div>

          <div class="catalog-info-area-mobile offset-1 col-10 mb-3">
            <div class="row no-gutters">
              <div class="col-8">
                <table class="table-info w-100">
                  <thead></thead>
                  <tbody>
                  <tr v-for="(sizePrice, key2) of eventPrice">
                    <template v-if="key2 == '1_1'">
                      <th><trans-text i18nKey="ui[7][21]"/></th>
                      <td>
                        <trans-text i18nKey="ui['7'][5]" :replaceData="{quantity:sizePrice.count}" />
                        <trans-text i18nKey="ui['7'][6]" :replaceData="{money:sizePrice.price}" />
                      </td>
                    </template>
                    <template v-if="key2 == '1_2'">
                      <th><trans-text i18nKey="ui[7][22]"/></th>
                      <td>
                        <trans-text i18nKey="ui['7'][5]" :replaceData="{quantity:sizePrice.count}" />
                        <trans-text i18nKey="ui['7'][6]" :replaceData="{money:sizePrice.price}" />
                      </td>
                    </template>
                    <template v-if="key2 == '2_1'">
                      <th><trans-text i18nKey="ui[7][23]"/></th>
                      <td>
                        <trans-text i18nKey="ui['7'][5]" :replaceData="{quantity:sizePrice.count}" />
                        <trans-text i18nKey="ui['7'][6]" :replaceData="{money:sizePrice.price}" />
                      </td>
                    </template>
                    <template v-if="key2 == '2_2'">
                      <th><trans-text i18nKey="ui[7][24]"/></th>
                      <td>
                        <trans-text i18nKey="ui['7'][5]" :replaceData="{quantity:sizePrice.count}" />
                        <trans-text i18nKey="ui['7'][6]" :replaceData="{money:sizePrice.price}" />
                      </td>
                    </template>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-4 price-info-wrap" style="">
                <div class="price-info d-flex flex-column h-100" style="">
                  <div class="price-label flex-grow-1">
                    <trans-text i18nKey="ui['6'][5]" />
                  </div>
                  <div class="price-value text-right">
                    <trans-text i18nKey="ui['7'][6]" :replaceData="{money:getSubTotal(eventPrice)}" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>

      <!-- 写真一覧 -->
      <div class="col-lg-9" >
        <div class="row mx-1-gutters">
          <component :is="photoComponent(cartPhoto)" :cartPhoto="cartPhoto" :cart="cart" v-for="cartPhoto in cartPhotos" :key="cartPhoto.id"
                     @toggleCartPhotoSizePopoverForm="toggleCartPhotoSizePopoverForm" @removeCartPhoto="removeCartPhoto" @changeCartPhotoPurchaseTarget="changeCartPhotoPurchaseTarget"
                     :ref="'photoComponent_' + cartPhoto.id">
          </component>
        </div>
      </div>
      <!-- 販売イベント情報-->
      <div class="col-lg-3 pl-4" v-if="!isMobileBreakpoint">
        <!--<button id="testA" @click="testA">test</button>-->


        <ul class="cart-info list-group" v-for="(eventPrice, key) of eventPrices">
          <li class="list-group-item event-info"><trans-text i18nKey="ui[7][4]"/>: {{getEventNameById(key).name}}</li>
          <li v-for="(sizePrice, key2) of eventPrice" class="list-group-item size-info">
            <template v-if="key2 == '1_1'">
              <div class="row w-100">
                <div class="col text-label">
                  <trans-text i18nKey="ui[7][21]"/>
                </div>
                <div class="col-auto text-right">
                  <div class="d-flex flex-column">
                    <div><trans-text i18nKey="ui['7'][5]" :replaceData="{quantity:sizePrice.count}" /></div>
                    <div><trans-text i18nKey="ui['7'][6]" :replaceData="{money:sizePrice.price}" /></div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="key2 == '1_2'">
              <div class="row w-100">
                <div class="col text-label">
                  <trans-text i18nKey="ui[7][22]"/>
                </div>
                <div class="col-auto text-right">
                  <div class="d-flex flex-column">
                    <div><trans-text i18nKey="ui['7'][5]" :replaceData="{quantity:sizePrice.count}" /></div>
                    <div><trans-text i18nKey="ui['7'][6]" :replaceData="{money:sizePrice.price}" /></div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="key2 == '2_1'">
              <div class="row w-100">
                <div class="col text-label">
                  <trans-text i18nKey="ui[7][23]"/>
                </div>
                <div class="col-auto text-right">
                  <div class="d-flex flex-column">
                    <div><trans-text i18nKey="ui['7'][5]" :replaceData="{quantity:sizePrice.count}" /></div>
                    <div><trans-text i18nKey="ui['7'][6]" :replaceData="{money:sizePrice.price}" /></div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="key2 == '2_2'">
              <div class="row w-100">
                <div class="col text-label">
                  <trans-text i18nKey="ui[7][24]"/>
                </div>
                <div class="col-auto text-right">
                  <div class="d-flex flex-column">
                    <div><trans-text i18nKey="ui['7'][5]" :replaceData="{quantity:sizePrice.count}" /></div>
                    <div><trans-text i18nKey="ui['7'][6]" :replaceData="{money:sizePrice.price}" /></div>
                  </div>
                </div>
              </div>
            </template>

          </li>


          <!--<li v-if="true">{{eventPrice}} {{key}}</li>-->
        </ul>

        <!--<ul class="cart-info list-group" v-for="cartEvent of cartEvents">-->
          <!--<li class="list-group-item event-info"><trans-text i18nKey="ui[7][4]"/>: {{cartEvent.name}}</li>-->
          <!--<li class="list-group-item size-info">-->
            <!--<div class="row w-100">-->
              <!--<div class="col text-label">-->
                <!--<trans-text i18nKey="ui[7][21]"/>-->
              <!--</div>-->
              <!--<div class="col-auto">-->
                <!--<div class="d-flex flex-column">-->
                  <!--<div><trans-text i18nKey="ui['91'][2]"/></div>-->
                  <!--<div><trans-text i18nKey="ui['91'][3]"/></div>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</li>-->
          <!--<li class="list-group-item size-info">-->
            <!--<div class="row w-100">-->
              <!--<div class="col text-label">-->
                <!--<trans-text i18nKey="ui[7][22]"/>-->
              <!--</div>-->
              <!--<div class="col-auto">-->
                <!--<div class="d-flex flex-column">-->
                  <!--<div><trans-text i18nKey="ui['91'][2]"/></div>-->
                  <!--<div><trans-text i18nKey="ui['91'][3]"/></div>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</li>-->
          <!--<li class="list-group-item size-info">-->
            <!--<div class="row w-100">-->
              <!--<div class="col text-label">-->
                <!--<trans-text i18nKey="ui[7][23]"/>-->
              <!--</div>-->
              <!--<div class="col-auto">-->
                <!--<div class="d-flex flex-column">-->
                  <!--<div><trans-text i18nKey="ui['91'][2]"/></div>-->
                  <!--<div><trans-text i18nKey="ui['91'][3]"/></div>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</li>-->
          <!--<li class="list-group-item size-info">-->
            <!--<div class="row w-100">-->
              <!--<div class="col text-label">-->
                <!--<trans-text i18nKey="ui[7][24]"/>-->
              <!--</div>-->
              <!--<div class="col-auto">-->
                <!--<div class="d-flex flex-column">-->
                  <!--<div><trans-text i18nKey="ui['91'][2]"/></div>-->
                  <!--<div><trans-text i18nKey="ui['91'][3]"/></div>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</li>-->
        <!--</ul>-->
        <!-- 合計情報 -->
        <ul class="cart-info list-group">
          <li class="list-group-item size-info totalCount">
            <div class="row w-100">
              <div class="col text-label"">
                <trans-text i18nKey="ui[7][7]"/>
              </div>
              <div class="col-auto w-100">
                <div class="d-flex flex-column">
                  <div><br></div>
                  <div class="text-right"><trans-text i18nKey="ui['7'][5]" :replaceData="{quantity:totalCount}" /></div>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item size-info totalPrice">
            <div class="row w-100">
              <div class="col text-label-price"">
                <trans-text i18nKey="ui[7][8]"/>
              </div>
              <div class="col-auto w-100">
                <div class="d-flex flex-column">
                  <div><br></div>
                  <div class="text-price text-right"><trans-text i18nKey="ui['7'][6]" :replaceData="{money:totalPrice}" /></div>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div style="margin:0 10px;">
          <div class="mt-5">
            <router-link tag="button" :to="{ name: 'mypage::event::order_form', params:{} }" class="btn-seque-order-confirm btn w-100 btn-warning">
              <trans-text i18nKey="ui[7][9]" />
            </router-link>
          </div>
          <div class="mt-2">
          <router-link tag="button" :to="{ path: $route.query.back_path }" class="btn w-100 btn-default">
            <trans-text i18nKey="ui[7][10]"/>
          </router-link>
          </div>
        </div>
      </div>
      <div class="offset-1 col-10" v-else>
        <div style="margin:0 10px;">
          <div class="mt-5">
            <router-link tag="button" :to="{ name: 'mypage::event::order_form', params:{} }" class="btn-seque-order-confirm btn w-100 btn-warning">
              <trans-text i18nKey="ui[7][9]" :adjustLangFontSizes="{}" />
            </router-link>
          </div>
          <div class="mt-2">
            <router-link tag="button" :to="{ path: $route.query.back_path }" class="btn w-100 btn-default">
              <trans-text i18nKey="ui[7][10]"/>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <cart-photo-size-change-popover v-show="isShowCartPhotoSizePopoverForm" ref="cartPhotoSizePopoverForm"
                                    @hideCartPhotoSizeChangePopover="hideCartPhotoSizeChangePopover" :photoSizeTargetCartPhoto="photoSizeTargetCartPhoto"
                                    @updateCartPhotoPhotoSize="updateCartPhotoPhotoSize"
    ></cart-photo-size-change-popover>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  import GroupHorizonPhoto from 'page/partials/Order/Cart/GroupHorizonPhoto.vue'
  import SnapHorizonPhoto from 'page/partials/Order/Cart/SnapHorizonPhoto.vue'
  import SnapVerticalPhoto from 'page/partials/Order/Cart/SnapVerticalPhoto.vue'

  import Cart from 'processor/Cart'
  import CartPhotoSizeChangePopover from 'components/popover/CartPhotoSizeChangePopover.vue'

  export default {
    extends:FormPartialBase,
    props:{
      eventPrices:{},
      totalPrice:0,
      totalCount:0,
      cart:{},
      cartPhotos:{},
      isShowCartPhotoSizePopoverForm:false,
    },
    components: {
      GroupHorizonPhoto,
      SnapHorizonPhoto,
      SnapVerticalPhoto,
      CartPhotoSizeChangePopover,
    },
    data () {
      return {
        photoSizeTargetCartPhoto:{},
      }
    },
    created(){

    },
    mounted(){
    },
    computed:{
      cartEvents(){
        let rets = []
        app.make("_").each(this.cartPhotos,(cartPhoto)=>{
          if(!cartPhoto.photo){ return }
          if(!cartPhoto.photo.event){ return }
          rets.push(cartPhoto.photo.event)
        })
        return app.make("_").uniqBy(rets,(item)=>{
          return item.id
        })
      },
      isMobileBreakpoint(){
        switch(this.$root.bootstrapBreakpoint){
          case "xl":
          case "lg":
            return false
          case "md":
          case "sm":
          case "xs":
            return true
          default:
            return null
        }
      },
    },
    methods:{
      getSubTotal(eventPrice){
        return app.make("_").reduce(eventPrice,function(sum, sizePrice) {
          return sum + sizePrice.price;
        }, 0)
      },
      getEventNameById(id){
        return app.make("_").find(this.cartEvents,(cartPhoto)=>{
            return cartPhoto.id == id

        })

      },
      changeCartPhotoPurchaseTarget(cartPhoto,isBuyTarget){
        if(isBuyTarget){
          Cart.addCartPhotoPurchaseTarget({cart_id:this.cart.id,cart_photo_id:cartPhoto.id})
            .then((res) => {
              if (res.status === "ng") {
                this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              }
              this.$emit("refleshTotal")
              this.$emit("refleshEventPrice")
            })
        }else{
          Cart.removeCartPhotoPurchaseTarget({cart_id:this.cart.id,cart_photo_id:cartPhoto.id})
            .then((res) => {
              if (res.status === "ng") {
                this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              }
              this.$emit("refleshTotal")
              this.$emit("refleshEventPrice")
              //dd("ok")
            })
        }

      },
      toggleCartPhotoSizePopoverForm(cartPhoto){
        //this.isShowCartPhotoSizePopoverForm = !this.isShowCartPhotoSizePopoverForm
        this.$emit("toggleIsShowCartPhotoSizePopoverForm")
        this.photoSizeTargetCartPhoto = cartPhoto

        this.$nextTick(function () {
          new Tether({
            element: this.$refs.cartPhotoSizePopoverForm.$refs.popover,
            //target:$("#testA"),
            target: this.$refs["photoComponent_"+cartPhoto.id][0].$el,
            //target: this.$refs.pageContent.$refs["linkOrderCatalog"+to.params.event_id][0].$el,
            attachment: 'top center',
            targetAttachment: 'bottom center',
          });
        })

      },
      testA(){
        this.$nextTick(function () {
          new Tether({
            element: this.$refs.cartPhotoSizePopoverForm.$refs.popover,
            //target:$("#testA"),
            target: this.$refs["photoComponent_"+111][0].$el,
            //target: this.$refs.pageContent.$refs["linkOrderCatalog"+to.params.event_id][0].$el,
            attachment: 'top center',
            targetAttachment: 'bottom center',
          });

        })
      },
      removeCartPhoto(cartPhoto){
        Cart.removeCartPhoto({cart_id:this.cart.id,cart_photo_id:cartPhoto.id})
          .then((res) => {
            if (res.status === "ng") {
              this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              return
            }
            let index =app.make("_").findIndex(this.cartPhotos,(o)=>o.id === cartPhoto.id)
            this.cartPhotos.splice(index, 1)
            this.$emit("refleshTotal")
            this.$emit("refleshEventPrice")
          })
      },
      photoComponent(cartPhoto){
        let photo = cartPhoto.photo || {}
        if(!photo.id){ return }
        let photoTypeCode = app.make("_").first(photo.photo_types).code
        let isVertically = app.make("_").first(photo.photo_thumbnails).is_vertically

        switch(String(photoTypeCode)){
          case "1": //スナップ
            return isVertically? "SnapVerticalPhoto" : "SnapHorizonPhoto"
          case "2": //集合写真
            return isVertically? "SnapVerticalPhoto" : "GroupHorizonPhoto"
        }
      },
      hideCartPhotoSizeChangePopover(){
        this.$emit("hideIsShowCartPhotoSizePopoverForm")
        //this.isShowCartPhotoSizePopoverForm=false
      },
      updateCartPhotoPhotoSize(cartPhoto,photoSizeId){
        Cart.updateCartPhotoSize({cart_id:this.cart.id,cart_photo_id:cartPhoto.id,photo_size_id:photoSizeId})
          .then((res) => {
            if (res.status === "ng") {
              this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              return
            }
            cartPhoto.photo_sizes.splice(0, cartPhoto.photo_sizes.length)
            cartPhoto.photo_sizes.push(res.data.photo_size)
            dd(111111111)
            this.$emit("refleshTotal")
            this.$emit("refleshEventPrice")
          })
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/_variables";

  .cart-info{
    font-size:.8rem;
    li{
      border-radius: 0;
      padding: .1rem .5rem;
    }
    .event-info{
      font-weight: bold;
      color: #fff;
      background-color: #82ba1d;
    }

  }

  .category-area{
    .list-group-item{
      border-radius: 0 !important;
      cursor: pointer;
      margin-right: 0;
      &.first-level {
        font-weight: bold;
        background-color: #c1df86;
        position: relative;
        &:before{
          font-family: FontAwesome;
          content: '\f054';
          font-size:1.2rem;
          color: #81ba1c;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(0);
          right: 5%;
        }
      }
      &.second-level {
        background-color: #f8ffeb;
      }
      &.third-level {
        background-color: #f8ffeb;
      }
    }
  }

  .info-area{
    border: 1px solid #919191;
    background-color: #fff;

    background-color: #ffffff;
  }

  .catalog-nav-wrap{
    position: relative;
    height: 100%;
    .catalog-nav{
      position: absolute;
      left:0;
      bottom: 0;
      li{
        position: relative;
        margin: 0 5px;
      }
      .prev,.next {
        border-radius: 0;
        a {
          border-radius: 0;
          color: #fff;
          background-color: #f79918;
        }
      }
      .page-no{
        a{
          margin-top: 4px;
          border: 1px solid #f79918;
          color: #f79918;
          font-weight:bold;
          font-size: 0.8rem;
          padding: 6px 8px;
        }
      }
    }
  }

  .seque-cart-btn{
    position: absolute;
    right: 0;
    top:0;
    &:before{
      font-family: FontAwesome;
      content: '\f291';
      font-size:1.2rem;
      color: #fff;
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(0);
      left: 5%;
    }
  }

    .order-history-area{
      .order-no-header {
        position: relative;
        .order-no {
          display: inline-block;
          background-color: #82ba1d;
          color: #fff;
          padding: 0 .5rem;
        }
        .order-status-wrap {
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          padding-left: 20px;
          background-color: #fff;
          width: 80px;
          .order-status {
            //          @extend %badge;
            position: absolute;
            right: 0;
            height: 100%;
          }
        }
      }
      //
      .download-btn{
        white-space:normal !important;
        word-wrap:break-word;
        padding-left: 2rem;
        position: relative;
        width:75%;
        &:before{
          font-family: FontAwesome;
          content: '\f019';
          font-size:1.2rem;
          color: #fff;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(0);
          left: 5%;
        }
      }

      /*//*/
      /*.form-group{*/
        /*margin-bottom:0;*/
      /*}*/

    }
    /*.order-history-area {*/



    /*}*/
    /*.orderer-header{*/
      /*color:#82ba1d;*/
      /*border:1px solid #82ba1d;*/
    /*}*/

    /*.form-list{*/
      /*padding:1rem;*/
    /*}*/

    /*.form-group{*/
      /*//    border-bottom: 1px solid #ccc;*/
    /*}*/
    /*.form-hr{*/
      /*height:1px;*/
      /*hr{*/
        /*margin:0;*/
      /*}*/
    /*}*/

    /*.description-area{*/
      /*a{*/
        /*color: #ea5536;*/
        /*text-decoration: underline;*/
        /*font-size: 0.9rem;*/
      /*}*/
      /*p{*/
        /*font-size: 0.9rem;*/
      /*}*/
    /*}*/


  ////
  .catalog-info-area-mobile{
    font-size: 0.8em;
    .order-no{
      font-weight: bold;
      background-color: #82ba1d;
      color: #fff;
    }
    .table-info{
      background-color: #fff;
      border:1px solid #8CBF42;
      th{
        padding:1px 4px;
        color:#8CBF42;
        border:1px solid #8CBF42;
      }
      td{
        padding:1px 4px;
        border:1px solid #8CBF42;
      }
    }
    .price-info-wrap{
      border:1px solid #ec4200;
      background-color: #fff;
      position: relative;
      .price-info{
        position: absolute;
        top:0;
        left:0;
        bottom: 0;
        right:0;
        width:100%;
        height:100%;
        .price-label{
          padding:1px 4px 0 4px;
          color: #ec4200;
        }
        .price-value{
          font-size: .7rem;
          padding:0 4px;
        }
      }
    }

  }

  .catalog-info-area{
    border: 1px solid #919191;
    background-color: #fff;
    font-size: 0.8rem;

    .order-no{
      font-weight: bold;
      background-color: #82ba1d;
      color: #fff;
    }
    .table-info{
      background-color: #fff;
      border:1px solid #8CBF42;
      th{
        padding:1px 4px;
        color:#8CBF42;
        border:1px solid #8CBF42;
      }
      td{
        padding:1px 4px;
        border:1px solid #8CBF42;
      }
    }
    .price-info{
      border:1px solid #ec4200;
      .price-label{
        padding:1px 4px 0 4px;
        color: #ec4200;
      }
      .price-value{
        font-size: 1.0rem;
        padding:0 4px;
      }

    }
  }

  .btn-seque-order-confirm{
    font-size:1rem;

    @media(min-width: map-get($grid-breakpoints, "lg")) {
      font-size:.7rem;
    }

  }

  .size-info{
    .text-label{
      color:#7eb800;
    }
    .text-label-price{
      color:#eb1100;
    }
    .text-price{
      font-size: 1.0rem;
    }
    .totalCount{
      background-color:#e5f1cc;
    }
    .totalPrice{
      background-color:#ffeee9;
    }
  }





</style>



// WEBPACK FOOTER //
// PageContent.vue?38bbfd84